import { createSelector } from 'reselect';

import { editorSelector } from 'modules/editor/store/selectors/editor';

export const toolbarSelector = createSelector(editorSelector, (editor) => editor.toolbar);
